"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/icon/style");
var _icon = _interopRequireDefault(require("antd/lib/icon"));
require("antd/lib/button/style");
var _button = _interopRequireDefault(require("antd/lib/button"));
require("antd/lib/input/style");
var _input = _interopRequireDefault(require("antd/lib/input"));
require("antd/lib/typography/style");
var _typography = _interopRequireDefault(require("antd/lib/typography"));
var _react = _interopRequireDefault(require("react"));
var _lodash = require("lodash");
var _RangeFilter = _interopRequireDefault(require("../RangeFilter"));
var _utils = require("../../../utils");
var _shared = require("./shared");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Text = _typography.default.Text;
var clinicianListConfig = function clinicianListConfig(dataSource, onRowClick) {
  var _classMap, _dataSource;
  var classMap = (_classMap = {}, _defineProperty(_classMap, _utils.AccountStatus.New, 'new'), _defineProperty(_classMap, _utils.AccountStatus.Active, 'active'), _defineProperty(_classMap, _utils.AccountStatus.Deactivated, 'inactive'), _classMap);
  var roles = (0, _utils.reformatDictionary)((0, _utils.getClinicianRoles)().map(function (_ref) {
    var value = _ref.value,
      text = _ref.text;
    return {
      id: value,
      label: text
    };
  }));
  var getLicensesString = function getLicensesString(licenses) {
    return licenses && licenses.length ? Array.from(licenses, function (item) {
      return item.licenseType;
    }).join(', ') : '';
  };
  var prepareStatusCell = function prepareStatusCell(_ref2) {
    var status = _ref2.status;
    if (!(0, _lodash.isNumber)(status)) {
      return;
    }
    var className = classMap[status] && "borderedColumn clinician-".concat(classMap[status]);
    return {
      props: {
        className: className
      },
      children: _shared.statusColumnConfig.render[status]
    };
  };
  var onRow = function onRow(record) {
    return {
      onClick: function onClick() {
        return onRowClick(record);
      }
    };
  };
  var getColumnSearchProps = function getColumnSearchProps(dataIndex) {
    var searchInput = null;
    var handleSearch = function handleSearch(selectedKeys, confirm, dataIndex) {
      confirm();
    };
    var handleReset = function handleReset(clearFilters) {
      clearFilters();
    };
    return {
      filterDropdown: function filterDropdown(_ref3) {
        var setSelectedKeys = _ref3.setSelectedKeys,
          selectedKeys = _ref3.selectedKeys,
          confirm = _ref3.confirm,
          clearFilters = _ref3.clearFilters;
        return /*#__PURE__*/_react.default.createElement("div", {
          style: {
            padding: 8
          }
        }, /*#__PURE__*/_react.default.createElement(_input.default, {
          ref: function ref(node) {
            searchInput = node;
          },
          placeholder: "Search ".concat((0, _lodash.startCase)(dataIndex)),
          value: selectedKeys[0],
          onChange: function onChange(e) {
            return setSelectedKeys(e.target.value ? [e.target.value] : []);
          },
          onPressEnter: function onPressEnter() {
            return handleSearch(selectedKeys, confirm, dataIndex);
          },
          style: {
            width: 188,
            marginBottom: 8,
            display: 'block'
          }
        }), /*#__PURE__*/_react.default.createElement(_button.default, {
          type: "primary",
          onClick: function onClick() {
            return handleSearch(selectedKeys, confirm, dataIndex);
          },
          icon: "search",
          size: "small",
          style: {
            width: 90,
            marginRight: 8,
            padding: 0
          }
        }, "Search"), /*#__PURE__*/_react.default.createElement(_button.default, {
          type: "default",
          onClick: function onClick() {
            return handleReset(clearFilters);
          },
          size: "small",
          style: {
            width: 90,
            padding: 0
          }
        }, "Reset"));
      },
      filterIcon: function filterIcon(filtered) {
        return /*#__PURE__*/_react.default.createElement(_icon.default, {
          type: "search",
          style: {
            color: filtered ? '#1890ff' : undefined
          }
        });
      },
      onFilter: function onFilter(value, record) {
        var licenses = getLicensesString(record.licenses);
        return licenses.toString().toLowerCase().includes(value.toLowerCase());
      },
      onFilterDropdownVisibleChange: function onFilterDropdownVisibleChange(visible) {
        if (visible) {
          setTimeout(function () {
            return searchInput.select();
          });
        }
      }
    };
  };
  dataSource = (_dataSource = dataSource) === null || _dataSource === void 0 ? void 0 : _dataSource.map(function (item) {
    return _objectSpread(_objectSpread({}, item), {}, {
      licenseType: getLicensesString(item.licenses)
    });
  });
  var licenseStateFilter = function licenseStateFilter(value, record) {
    if (!record.licenses || !record.licenses.length) {
      return false;
    }
    var states = Array.from(record.licenses, function (item) {
      return item.state;
    });
    return states.includes(value);
  };
  var columns = [{
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    filters: _shared.statusColumnConfig.filters,
    onFilter: (0, _utils.filter)('status'),
    render: function render(id, record) {
      return prepareStatusCell(record);
    },
    fixed: 'left',
    sorter: (0, _utils.stringSorter)('status'),
    width: 100
  }, {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    sorter: (0, _utils.multiStringSorter)(['lastName', 'firstName']),
    render: _shared.renderNameColumn,
    fixed: 'left',
    width: 180
  }, {
    title: 'Role',
    dataIndex: 'role',
    key: 'role',
    filters: roles.filters,
    onFilter: (0, _utils.filter)('role'),
    sorter: (0, _utils.stringSorter)('role'),
    render: function render(id, record) {
      return roles.render[record.role];
    },
    width: 160
  }, _objectSpread(_objectSpread({
    title: 'License Type',
    dataIndex: 'licenseType',
    sorter: (0, _utils.stringSorter)(function (record) {
      return getLicensesString(record.licenses);
    }),
    key: 'licenseType'
  }, getColumnSearchProps('licenseType')), {}, {
    width: 160
  }), {
    title: 'State',
    dataIndex: 'state',
    key: 'state',
    filters: _shared.statesColumnConfig.filters,
    onFilter: licenseStateFilter,
    sorter: (0, _utils.stringSorter)(function (record) {
      return (0, _utils.getStatesString)(record.licenses);
    }),
    render: function render(id, record) {
      return /*#__PURE__*/_react.default.createElement(Text, {
        type: "secondary"
      }, (0, _utils.getStatesString)(record.licenses));
    },
    width: 160
  }, {
    title: 'Patients',
    dataIndex: 'patients',
    key: 'patients',
    sorter: (0, _utils.digitSorter)('patients'),
    width: 120
  }, {
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
    sorter: (0, _utils.stringSorter)('email')
  }, {
    title: 'Last Activity',
    dataIndex: 'lastActivity',
    key: 'lastActivity',
    filterDropdown: function filterDropdown(props) {
      return /*#__PURE__*/_react.default.createElement(_RangeFilter.default, props);
    },
    onFilter: (0, _utils.dateRangeFilter)('lastActivity'),
    render: function render(id, record) {
      return /*#__PURE__*/_react.default.createElement(Text, {
        type: "secondary"
      }, (0, _utils.formatDate)(record.lastActivity));
    },
    sorter: (0, _utils.timeSorter)('lastActivity'),
    width: 180
  }, {
    title: 'Calls Made',
    dataIndex: 'callsMade',
    key: 'callsMade',
    render: function render(id, record) {
      return /*#__PURE__*/_react.default.createElement(Text, {
        type: "secondary"
      }, record.callsMade);
    },
    sorter: (0, _utils.digitSorter)('callsMade'),
    width: 140
  }, {
    title: 'Join Date',
    dataIndex: 'joinDate',
    key: 'joinDate',
    defaultSortOrder: 'descend',
    filterDropdown: function filterDropdown(props) {
      return /*#__PURE__*/_react.default.createElement(_RangeFilter.default, props);
    },
    onFilter: (0, _utils.dateRangeFilter)('joinDate'),
    render: function render(id, record) {
      return /*#__PURE__*/_react.default.createElement(Text, {
        type: "secondary"
      }, (0, _utils.formatDate)(record.joinDate));
    },
    sorter: (0, _utils.timeSorter)('joinDate'),
    width: 200
  }];
  return {
    columns: columns,
    dataSource: dataSource,
    onRow: onRow,
    rowKey: 'id',
    scroll: {
      x: 1700
    }
  };
};
var _default = clinicianListConfig;
exports.default = _default;